import { RichTextEditor as MantineRichTextEditor, RichTextEditorControlProps } from "@mantine/tiptap";
import clsx from "clsx";
import { FunctionComponent } from "react";
import styles from "../rich-text-editor.module.scss";
import { faStrikethrough } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "../../icon";
import { useEditorDisabled } from "../use-editor-disabled";

const StrikethroughIcon = () => <Icon icon={faStrikethrough} size="xs" />;

export const Strikethrough: FunctionComponent<RichTextEditorControlProps> = ({ className, disabled, ...other }) => {
    const effectiveDisabled = useEditorDisabled(disabled);
    return (
        <MantineRichTextEditor.Strikethrough
            className={clsx(styles["control"], className)}
            disabled={effectiveDisabled}
            {...other}
            icon={StrikethroughIcon}
        />
    );
};

Strikethrough.displayName = "RichTextEditor.Strikethrough";
